// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ff4b66e3","977":"5e09d511"}[chunkId] + ".chunk.js";
};